import { render } from "./difficultProportionPie.vue?vue&type=template&id=7fafc070&scoped=true"
import script from "./difficultProportionPie.vue?vue&type=script&lang=js"
export * from "./difficultProportionPie.vue?vue&type=script&lang=js"

import "./difficultProportionPie.vue?vue&type=style&index=0&id=7fafc070&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fafc070"]])

export default __exports__